import {PrintableCalendarAspectRatios} from "@/enums/PrintableCalendarAspectRatios";
import {OrientationTypes} from "@/enums/OrientationTypes";
import VueDragResize from 'vue-drag-resize';
import moment from "moment";

export default {
  name: "PrintableCalendarHeader",
  components: {
    VueDragResize
  },
  props: {
    printCalendarFormat: {
      type: String
    },
    typeToLabel: {
      type: Object
    },
    calendarStartDay: {
      type: Date
    },
    isCalendarFilteredByWings: {
      type: Boolean
    },
    isPrintCalendar: {
      type: Boolean
    },
    isRemoveBorder: {
      type: Boolean
    },
    isCalendarMonthLocation: {
      type: Boolean
    },
    calendarDescription: {
      type: String
    },
    locations: {
      type: Array
    },
    isPdfHeader: {
      type: Boolean
    },
    facilityLogo: {
      type: String
    },
    isPreviewHeader: {
      type: Boolean
    },
    locationsWithShortCode: {
      type: Array
    },
    headerFont: {
      type: String
    },
    headerSize: {
      type: String
    },
    headerFontColor: {
      type: String
    },
    locationKeysSize: {
      type: String
    },
    locationKeys: {
      type: Boolean
    },
    paperFormat: {
      type: String
    },
    pdfOrientation: {
      type: String
    },
    careLevels: {
      type: Array
    },
    selectedWingsPrintableCalendar: {
      type: Array
    },
    isUseWingsCustomNameEnabled: {
      type: Boolean
    },
    wingsCustomNameDescription: {
      type: String
    },
    isWeekCompact: {
      type: Boolean
    },
    printableCalendarCustomImage: {
      type: String
    },
    logoSizeComputed: {
      type: Object
    },
    customPhotoSizeComputed: {
      type: Object
    },
    isUseFacilityCustomNameEnabled: {
      type: Boolean
    },
    facilityCustomName: {
      type: String
    },
    locationsSizeHeaderComputed: {
      type: Object
    },
    customTextBoxSizeHeaderComputed: {
      type: Object
    },
    inputCustomBoxColor: {
      type: String
    },
    inputCustomBoxSize: {
      type: String
    },
    printableCalendarImages: {
      type: Array
    },
    printableCalendarTextBoxes: {
      type: Array
    },
    pagination: {
      type: Object
    },
    pdfPage: {
      type: Number
    },
    pdfIs2Week: {
      type: Boolean
    },
    is2WeeksHeader: {
      type: Boolean
    },
    locationsKeys: {
      type: Array
    },
    printableCalendarUrl: {
      type: String
    },
    printableCalendarMainPDF: {
      type: Object
    },
    printableCalendarMainPDFSlide: {
      type: Object
    }
  },
  computed: {
    isMonth() {
      return this.printCalendarFormat === this.typeToLabel.month;
    },
    isWeek() {
      return this.printCalendarFormat === this.typeToLabel.week;
    },
    is2Weeks() {
      return this.printCalendarFormat === this.typeToLabel['2weeks'];
    },
    isDay() {
      return this.printCalendarFormat === this.typeToLabel.day;
    },
    isLocalhost() {
      return window.location.hostname === 'localhost';
    },
    isUSPdf() {
      return this.$store.state.facilityModule.selectedFacility.countryIso === "US";
    },
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    headerSizeModify() {
      if(this.isUSPdf) {
        if(this.printableCalendarUrl) {
          if(this.isMonth) {
            if(this.isLetter) {
              return `${Math.round(parseFloat(this.headerSize) / 1.6)}px`
            }
            return this.headerSize;
          }

          if(this.isWeek || this.is2Weeks) {
            if(this.isTabloid) {
              return `${Math.round(parseFloat(this.headerSize) * 1)}px`
            }

            if(this.isLetter) {
              return `${Math.round(parseFloat(this.headerSize) / 1.7)}px`
            }
          }

          if(this.isDay) {
            if(this.isTabloid) {
              return `${Math.round(parseFloat(this.headerSize))}px`
            }
          }
        } else {
          if(this.isMonth) {
            if(this.isLetter) {
              return `${Math.round(parseFloat(this.headerSize) / 1.6)}px`
            }
            return this.headerSize;
          }

          if(this.isWeek || this.is2Weeks) {
            if(this.isTabloid) {
              return `${Math.round(parseFloat(this.headerSize) * 1.08)}px`
            }

            if(this.isLetter) {
              return `${Math.round(parseFloat(this.headerSize) / 1.5)}px`
            }
          }

          if(this.isDay) {
            if(this.isTabloid) {
              return `${Math.round(parseFloat(this.headerSize))}px`
            }
          }
        }
      } else {
        if(this.printableCalendarUrl) {
          if(this.isMonth) {
            if(this.isA3) {
              return `${Math.round(parseFloat(this.headerSize) * 1.1)}px`
            }
            return `${Math.round(parseFloat(this.headerSize) / 1.3)}px`
          }

          if(this.isWeek || this.is2Weeks) {
            if(this.isA3) {
              return `${Math.round(parseFloat(this.headerSize) * 1.05)}px`
            }
            return `${Math.round(parseFloat(this.headerSize) / 1.43)}px`
          }

          if(this.isDay) {
            if(this.isA3) {
              return `${Math.round(parseFloat(this.headerSize) / 1.3)}px`
            }
          }
        } else {
          if(this.isMonth) {
            if(this.isA3) {
              return `${Math.round(parseFloat(this.headerSize) * 1.1)}px`
            }

            return `${Math.round(parseFloat(this.headerSize) / 1.3)}px`
          }

          if(this.isWeek || this.is2Weeks) {
            if(this.isA3) {
              return `${Math.round(parseFloat(this.headerSize) * 1.15)}px`
            }
            return `${Math.round(parseFloat(this.headerSize) / 1.3)}px`
          }

          if(this.isDay) {
            if(this.isA3) {
              return `${Math.round(parseFloat(this.headerSize) / 1.3)}px`
            }
          }
        }
      }

      return `${Math.round(parseFloat(this.headerSize) / 2)}px`;
    },
    inputCustomBoxSizeModify() {
      if(this.isUSPdf) {
        if(this.isLetter) {
          return `${Math.round(parseFloat(this.inputCustomBoxSize) / 1.55)}px`;
        } else {
          return `${Math.round(parseFloat(this.inputCustomBoxSize) / 1.05)}px`;
        }
      } else {
        if(this.isA3) {
          return `${Math.round(parseFloat(this.inputCustomBoxSize) / 0.95)}px`;
        } else {
          return `${Math.round(parseFloat(this.inputCustomBoxSize) / 1.4)}px`;
        }
      }
    },
    locationKeysSizeModify() {
      if(this.isUSPdf) {
        if(this.isLetter) {
          return `${Math.round(parseFloat(this.locationKeysSize) / 1.55)}px`;
        } else {
          return `${Math.round(parseFloat(this.locationKeysSize) / 1.05)}px`;
        }
      } else {
        if(this.isA3) {
          return `${Math.round(parseFloat(this.locationKeysSize) / 0.95)}px`;
        } else {
          return `${Math.round(parseFloat(this.locationKeysSize) / 1.4)}px`;
        }
      }
    },
    isLetter() {
      return this.paperFormat === PrintableCalendarAspectRatios.letter;
    },
    isTabloid() {
      return this.paperFormat === PrintableCalendarAspectRatios.tabloid;
    },
    isA3() {
      return this.paperFormat === PrintableCalendarAspectRatios.a3;
    },
    isA4() {
      return this.paperFormat === PrintableCalendarAspectRatios.a4;
    },
    isPortrait() {
      return this.pdfOrientation === OrientationTypes.Portrait;
    },
    isLandscape() {
      return this.pdfOrientation === OrientationTypes.Landscape;
    },
    selectedWings() {
      const wingsIds = this.selectedWingsPrintableCalendar.map(x => x.id);
      const selectedCareLevelIds = this.careLevels
        .filter(level => level.wingsIds.every(id => wingsIds.includes(id)))
        .map(level => level.id);

      const wings = this.selectedWingsPrintableCalendar
        .filter(wing => !wing.careLevelsIds.some(id => selectedCareLevelIds.includes(id)))
        .map(wing => wing.name);

      const careLevels = this.careLevels
        .filter(level => selectedCareLevelIds.includes(level.id))
        .map(level => level.name);

      return `${[...careLevels, ...wings].join(', ')}`;
    },
    calendarDates() {
      if(this.isMonth || this.isDay) {
        return moment(this.calendarStartDay).format('MMMM YYYY');
      }

      if((this.isWeek || this.is2Weeks) && this.calendarStartDay) {
        const startDay: moment.Moment = moment(this.calendarStartDay);
        const endDay: moment.Moment = moment(this.calendarStartDay).add(6, 'days');
        if (startDay.year() === endDay.year()) {
          return `${startDay.format('MMMM DD')} - ${endDay.format('MMMM DD')}, ${startDay.format('YYYY')}`
        }
        else {
          return `${startDay.format('MMMM DD')}, ${startDay.format('YYYY')} - ${endDay.format('MMMM DD')}, ${endDay.format('YYYY')}`
        }
      }
    },
    calendarWidth() {
      if (this.isLetter && this.isUSPdf) {
        return this.isDay ? 1538 : this.printableCalendarUrl ? 1538 : 1495;
      }

      if (this.isA3 && this.isDay) {
        return this.printableCalendarUrl ? 1400 : 1368;
      }

      return this.isUSPdf ? (this.printableCalendarUrl ? 1540 : 1496) : (this.printableCalendarUrl ? 1400 : 1376);
    },
    calendarHeight() {
      if (this.isLetter && this.isUSPdf) {
        return this.isDay ? (this.printableCalendarUrl ? 2145 : 2154) : 1135;
      }

      if (this.isTabloid && this.isUSPdf && this.isDay) {
        return this.printableCalendarUrl ? 975 : 994;
      }

      if ((this.isA4 || this.isA3) && this.isDay) {
        return this.printableCalendarUrl ? 2145 : (this.isA3 ? 1950 : 1954);
      }

      return this.printableCalendarUrl ? 990 : 989;
    }
  },
  methods: {
    onInputCalendarDescription() {
      this.$emit('setCalendarDescription', this.calendarDescription);
    },
    onInputFacilityCustomName() {
      this.$emit('setFacilityCustomName', this.facilityCustomName)
    },
    uppercase: function (value) {
      if (!value) return '';

      const foundLocationKey = this.locationsKeys.find(x => x.name.trimEnd() === value.trimEnd());
      if (foundLocationKey) {
        return foundLocationKey.key;
      }

      const foundLocation = this.locationsWithShortCode.find(x => x.name.trimEnd() === value.trimEnd());
      if (foundLocation) {
        return foundLocation.shortCode;
      }

      value = value.toString()
      return value.slice(0, 2).toUpperCase()
    },
    resize(newRect) {
      this.logoSizeComputed.width = newRect.width;
      this.logoSizeComputed.height = newRect.height;
      this.logoSizeComputed.top = newRect.top;
      this.logoSizeComputed.left = newRect.left;
    },
    resizeLocations(newRect) {
      this.locationsSizeHeaderComputed.width = newRect.width;
      this.locationsSizeHeaderComputed.height = newRect.height;
      this.locationsSizeHeaderComputed.top = newRect.top;
      this.locationsSizeHeaderComputed.left = newRect.left;
    },
    resizeImage(newRect, index) {
      this.printableCalendarImages[index].position.width = newRect.width;
      this.printableCalendarImages[index].position.height = newRect.height;
      this.printableCalendarImages[index].position.top = newRect.top;
      this.printableCalendarImages[index].position.left = newRect.left;
    },
    resizeTextBox(newRect, index) {
      this.printableCalendarTextBoxes[index].position.width = newRect.width;
      this.printableCalendarTextBoxes[index].position.height = newRect.height;
      this.printableCalendarTextBoxes[index].position.top = newRect.top;
      this.printableCalendarTextBoxes[index].position.left = newRect.left;
    },
    calculateCalendarWidth() {
      if(this.isLetter && this.isUSPdf) {
        if(this.isDay) {
          return this.printableCalendarUrl ? 1538 : 1496;
        } else {
          return this.printableCalendarUrl ? 1538 : 1500;
        }
      }

      if(this.isA3 && this.isDay) {
        return this.printableCalendarUrl ? 1400 : 1368;
      }

      return this.isUSPdf
        ? (this.printableCalendarUrl ? 1540 : 1496)
        : (this.printableCalendarUrl ? 1400 : 1376);
    },
    calculateCalendarWidthPixel(percentLeft: number) {
      const mainPdfWidth = this.printableCalendarMainPDF.offsetWidth - (this.printableCalendarUrl ? 100 : 0);
      return (percentLeft / 100) * mainPdfWidth;
    },
    calculateCalendarHeight() {
      if(this.isLetter && this.isUSPdf) {
        if(this.isDay) {
          return this.printableCalendarUrl ? 2145 : 2154;
        } else {
          return 1135;
        }
      }

      if(this.isTabloid && this.isUSPdf && this.isDay) {
        return this.printableCalendarUrl ? 975 : 994;
      }

      if(this.isA4 && this.isDay) {
        return this.printableCalendarUrl ? 2145 : 1954;
      }

      if(this.isA3 && this.isDay) {
        return this.printableCalendarUrl ? 2145 : 1950;
      }

      return this.isUSPdf
        ? (this.printableCalendarUrl ? 990 : 994)
        : (this.printableCalendarUrl ? 990 : 994);
    },
    calculateCalendarHeightPixel(percentTop: number) {
      const mainPdfHeight = this.printableCalendarMainPDFSlide.offsetHeight - (this.printableCalendarUrl ? 100 : 0);
      return (percentTop / 100) * mainPdfHeight;
    },

    calculateTextBoxX(index) {
      if(this.isPdfHeader && this.printableCalendarMainPDF) {
        const originalWidth = this.calculateCalendarWidth();
        const percentLeft = (this.printableCalendarTextBoxes[index].position.left / originalWidth) * 100;
        return this.calculateCalendarWidthPixel(percentLeft)
      } else {
        return this.printableCalendarTextBoxes[index].position.left;
      }
    },
    calculateTextBoxY(index) {
      if(this.isPdfHeader && this.printableCalendarMainPDFSlide) {
        const originalHeight = this.calculateCalendarHeight()
        const percentTop = (this.printableCalendarTextBoxes[index].position.top / originalHeight) * 100;
        return this.calculateCalendarHeightPixel(percentTop);
      } else {
        return this.printableCalendarTextBoxes[index].position.top
      }
    },
    calculateTextBoxW(index) {
      if(this.isPdfHeader && this.printableCalendarMainPDF) {
        const originalWidth = this.calculateCalendarWidth();
        const percentWidth = (this.printableCalendarTextBoxes[index].position.width / originalWidth) * 100;
        return this.calculateCalendarWidthPixel(percentWidth);
      } else {
        return this.printableCalendarTextBoxes[index].position.width;
      }
    },
    calculateTextBoxH(index) {
      if(this.isPdfHeader && this.printableCalendarMainPDFSlide) {
        const originalHeight = this.calculateCalendarHeight();
        const percentTop = (this.printableCalendarTextBoxes[index].position.height / originalHeight) * 100;
        return this.calculateCalendarHeightPixel(percentTop);
      } else {
        return this.printableCalendarTextBoxes[index].position.height;
      }
    },


    calculateImageX(index) {
      if(this.isPdfHeader && this.printableCalendarMainPDF) {
        const originalWidth = this.calculateCalendarWidth();
        const percentLeft = (this.printableCalendarImages[index].position.left / originalWidth) * 100;
        return this.calculateCalendarWidthPixel(percentLeft);
      } else {
        return this.printableCalendarImages[index].position.left;
      }
    },
    calculateImageY(index) {
      if(this.isPdfHeader && this.printableCalendarMainPDFSlide) {
        const originalHeight = this.calculateCalendarHeight();
        const percentTop = (this.printableCalendarImages[index].position.top / originalHeight) * 100;
        return this.calculateCalendarHeightPixel(percentTop);
      } else {
        return this.printableCalendarImages[index].position.top
      }
    },
    calculateImageW(index) {
      if(this.isPdfHeader && this.printableCalendarMainPDF) {
        const originalWidth = this.calculateCalendarWidth();
        const percentWidth = (this.printableCalendarImages[index].position.width / originalWidth) * 100;
        return this.calculateCalendarWidthPixel(percentWidth);
      } else {
        return this.printableCalendarImages[index].position.width;
      }
    },
    calculateImageH(index) {
      if(this.isPdfHeader && this.printableCalendarMainPDFSlide) {
        const originalHeight = this.calculateCalendarHeight();
        const percentTop = (this.printableCalendarImages[index].position.height / originalHeight) * 100;
        return this.calculateCalendarHeightPixel(percentTop);
      } else {
        return this.printableCalendarImages[index].position.height;
      }
    },

    calculateLocationsX() {
      if(this.isPdfHeader && this.printableCalendarMainPDF) {
        const originalWidth = this.calculateCalendarWidth();
        const percentLeft = (this.locationsSizeHeaderComputed.left / originalWidth) * 100;
        return this.calculateCalendarWidthPixel(percentLeft);
      } else {
        return this.locationsSizeHeaderComputed.left;
      }
    },
    calculateLocationsY() {
      if(this.isPdfHeader && this.printableCalendarMainPDFSlide) {
        const originalHeight = this.calculateCalendarHeight();
        const percentTop = (this.locationsSizeHeaderComputed.top / originalHeight) * 100;
        return this.calculateCalendarHeightPixel(percentTop);
      } else {
        return this.locationsSizeHeaderComputed.top
      }
    },
    calculateLocationsW() {
      if(this.isPdfHeader && this.printableCalendarMainPDF) {
        const originalWidth = this.calculateCalendarWidth();
        const percentWidth = (this.locationsSizeHeaderComputed.width / originalWidth) * 100;
        return this.calculateCalendarWidthPixel(percentWidth);
      } else {
        return this.locationsSizeHeaderComputed.width;
      }
    },
    calculateLocationsH() {
      if(this.isPdfHeader && this.printableCalendarMainPDFSlide) {
        const originalHeight = this.calculateCalendarHeight();
        const percentTop = (this.locationsSizeHeaderComputed.height / originalHeight) * 100;
        return this.calculateCalendarHeightPixel(percentTop);
      } else {
        return this.locationsSizeHeaderComputed.height;
      }
    },


    calculateLogoX() {
      if(this.isPdfHeader && this.printableCalendarMainPDF) {
        const originalWidth = this.calculateCalendarWidth();
        const percentLeft = ((this.logoSizeComputed.left - 20)  / originalWidth) * 100;
        return this.calculateCalendarWidthPixel(percentLeft);
      } else {
        return this.logoSizeComputed.left;
      }
    },
    calculateLogoY() {
      if(this.isPdfHeader && this.printableCalendarMainPDFSlide) {
        const originalHeight = this.calculateCalendarHeight();
        const percentTop = ((this.logoSizeComputed.top - 15) / originalHeight) * 100;
        return this.calculateCalendarHeightPixel(percentTop);
      } else {
        return this.logoSizeComputed.top
      }
    },
    calculateLogoW() {
      if(this.isPdfHeader && this.printableCalendarMainPDF) {
        const originalWidth = this.calculateCalendarWidth();
        const percentWidth = ((this.logoSizeComputed.width + 5) / originalWidth) * 100;
        return this.calculateCalendarWidthPixel(percentWidth);
      } else {
        return this.logoSizeComputed.width;
      }
    },
    calculateLogoH() {
      if(this.isPdfHeader && this.printableCalendarMainPDFSlide) {
        const originalHeight = this.calculateCalendarHeight();
        const percentTop = ((this.logoSizeComputed.height + 5) / originalHeight) * 100;
        return this.calculateCalendarHeightPixel(percentTop);
      } else {
        return this.logoSizeComputed.height;
      }
    },

    isActiveItemByPage(item) {
      const isAllWeek = ['all', 1].includes(item.week);
      const isTwoWeek = ['all', 2].includes(item.week);
      if (!this.isPdfHeader) {
        return !this.is2WeeksHeader && isAllWeek || this.is2WeeksHeader && isTwoWeek;
      } else {
        return !this.pdfIs2Week && isAllWeek || this.pdfIs2Week && isTwoWeek;
      }
    },
    isActiveItemByWeeks(item) {
      const isPageActive = !this.isPdfHeader
        ? item.page === this.pagination.current_page
        : item.page === this.pdfPage;

      const isPaginationActive = this.pagination.pages === 1 || item.page === 'all';

      return isPageActive || isPaginationActive;
    },

    roundToNearestStep(num) {
      const intPart = Math.floor(num);
      let decimalPart = num - intPart;

      if (decimalPart < 0.25) decimalPart = 0;
      else if (decimalPart < 0.75) decimalPart = 0.5;
      else decimalPart = 1;

      return intPart + decimalPart;
    },
    textBoxSizeModify(fontSize) {
      if(this.isUSPdf) {
        if(this.printableCalendarUrl) {
          if(this.isLetter) {
            return this.isDay ? `${this.roundToNearestStep(parseFloat(fontSize) / 2.1)}px` : `${this.roundToNearestStep(parseFloat(fontSize) / 1.55)}px`;
          } else {
            return this.isDay ? `${this.roundToNearestStep(parseFloat(fontSize) / 0.97)}px` : `${this.roundToNearestStep(parseFloat(fontSize) / 1)}px`;
          }
        } else {
          if(this.isLetter) {
            return this.isDay ? `${this.roundToNearestStep(parseFloat(fontSize) / 1.8)}px` : `${this.roundToNearestStep(parseFloat(fontSize) / 1.45)}px`;
          } else {
            return this.isDay ? `${this.roundToNearestStep(parseFloat(fontSize) / 0.9)}px` : `${this.roundToNearestStep(parseFloat(fontSize) / 0.95)}px`;
          }
        }
      } else {
        if(this.printableCalendarUrl) {
          if(this.isA3) {
            return this.isDay ? `${this.roundToNearestStep(parseFloat(fontSize) / 1.35)}px` : `${this.roundToNearestStep(parseFloat(fontSize) / 0.95)}px`;
          } else {
            return this.isDay ? `${this.roundToNearestStep(parseFloat(fontSize) / 1.95)}px` : `${this.roundToNearestStep(parseFloat(fontSize) / 1.4)}px`;
          }
        } else {
          if(this.isA3) {
            return this.isDay ? `${this.roundToNearestStep(parseFloat(fontSize) / 1.23)}px` : `${this.roundToNearestStep(parseFloat(fontSize) / 0.9)}px`;
          } else {
            return this.isDay ? `${this.roundToNearestStep(parseFloat(fontSize) / 1.75)}px` : `${this.roundToNearestStep(parseFloat(fontSize) / 1.3)}px`;
          }
        }
      }
    }
  },
}